<template>
  <div>
    <span class="error">{{ error }}</span> <br />

    <div v-if="show_navigation_buttons">
      <ion-row>
        <ion-col>
          <ion-button class="button_nav wizbutton" @click="go_to_first_step">
            <p>Back</p>
          </ion-button>
        </ion-col>
        <ion-col class="ion-text-right">
          <ion-button class="button_nav wizbutton" @click="go_to_third_step">
            <p>Next</p>
          </ion-button>
        </ion-col>
      </ion-row>
    </div>

    <div v-if="status_search_text">
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col>
            <ion-searchbar
              debounce="800"
              style="padding: 0px"
              placeholder="Search for SKUs"
              v-model="search_term"
              show-cancel-button="always"
              @ionChange="get_items"
              @ionCancel="cancelSearch"
            ></ion-searchbar>
          </ion-col>
        </ion-row>
        <ion-row v-if="status_search_results==false" class="ion-align-items-center">
          <ion-col class="ion-text-center">
            <ion-button expand="block"  @click="start_scan">
              <ion-icon slot="icon-only" :icon="qrCodeOutline"></ion-icon>
              &nbsp;<span>Scan Code</span>
            </ion-button>
<!--             <ion-button expand="block"  @click="start_scan_with_html5">
              <ion-icon slot="icon-only" :icon="qrCodeOutline"></ion-icon>
              &nbsp;<span>Scan Code with HTML 5</span>
            </ion-button> -->
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <!--
        <div v-if="status_scan_product">
            <ScanQRcode @result_scanned="search_scanned_product" ></ScanQRcode>
        </div>
        -->

    <div class="results" v-if="status_search_results">
      <ion-list>
        <ion-item v-for="item in items_for_display" :key="item.pitem_id">
          <ion-grid>
            <ion-row>
              <ion-col size="4" size-md="3">
                <ion-label> SKU: </ion-label> {{ item.pitem_code }}
              </ion-col>
              <ion-col size="8" size-md="5">
                <ion-label> Name: </ion-label> {{ item.prod_name }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>by</ion-label>
                {{ item.ent_fullname }}
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="8">
                <ion-label> Dimension: </ion-label>
                {{ item.pitem_dimension }}
                <ion-label> Description: </ion-label>
                {{ item.prod_descr }}
              </ion-col>
              <ion-col size="12" size-md="4" class="ion-text-right">
                 <ion-button @click="go_to_item_info(item)">Select</ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-list>

      <div v-if="show_scroll">
        <ion-infinite-scroll
          @ionInfinite="loadData($event, true)"
          threshold="100px"
          id="infinite-scroll"
          :disabled="false"
        >
          <ion-infinite-scroll-content
            loading-spinner="bubbles"
            loading-text="Loading more data..."
          >
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </div>

    <div class="information" v-if="status_item_info">
      <div class="ion-text-right">
        <ion-button color="danger" size="small" v-if="status_edit_item" @click="remove()">Delete from List</ion-button>
      </div>
      <ion-grid>
        <ion-row>
          <ion-col size="7">
            <div style="display: flex;flex-wrap: wrap;">
              <ion-col size="12" size-md="4">
                <ion-label>Vendor: </ion-label><br>
                {{ selected_item.ent_fullname }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>SKU: </ion-label><br>
                {{ selected_item.pitem_code }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>Name: </ion-label><br>
                {{ selected_item.prod_name }}
              </ion-col>
            </div>
          </ion-col>
          <ion-col size="5">
            <img :src="selected_item.image_url" style="max-width:100%;max-height:25vh;" />
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" size-md="6">
            <div style="display: flex;flex-wrap: wrap;">
              <ion-col size="3">
                <ion-label>Price: </ion-label>
              </ion-col>
              <ion-col size="9">
                ${{ selected_item.pitem_price_designer }} / {{selected_item.pitem_unit}}
              </ion-col>
            </div>
          </ion-col>
          <ion-col size="12" size-md="6">
            <div style="display: flex;flex-wrap: wrap;">
              <ion-col size="12">
                <ion-label>Description: </ion-label><br><br>
                <span v-html="selected_item.pitem_description"></span>
              </ion-col>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col size="12" size-md="6" class="ion-text-center">
              <ion-button size="small" color="warning" v-if="tearsheet_enabled==true && tearsheet_checked==true" @click="tearsheet_checked=false">Tearsheet</ion-button>
              <ion-button size="small" color="medium" v-if="tearsheet_enabled==true && tearsheet_checked!=true" @click="tearsheet_checked=true">No Tearsheet</ion-button>

              <ion-button size="small" color="primary" v-if="memo_enabled==true && memo_checked==true" @click="memo_checked=false">Sample</ion-button>
              <ion-button size="small" color="medium" v-if="memo_enabled==true && memo_checked!=true" @click="memo_checked=true">No Sample</ion-button>

              <ion-button size="small" color="success" v-if="quote_enabled==true && quote_checked==true" @click="quote_checked=false">Quote</ion-button>
              <ion-button size="small" color="medium" v-if="quote_enabled==true && quote_checked!=true" @click="quote_checked=true">No Quote</ion-button>
          </ion-col>
<!--           <ion-col size="4">
            <ion-label>Tearsheet</ion-label><br />
            <ion-checkbox
              @update:modelValue="tearsheet_checked = $event"
              :modelValue="tearsheet_checked"
            ></ion-checkbox>
            <br />
          </ion-col>
          <ion-col size="4">
            <ion-label>Memo</ion-label><br />
            <ion-checkbox
              @update:modelValue="memo_checked = $event"
              :modelValue="memo_checked"
            ></ion-checkbox>
            <br />
          </ion-col>
          <ion-col size="4">
            <ion-label>Quote</ion-label><br />
            <ion-checkbox
              @update:modelValue="quote_checked = $event"
              :modelValue="quote_checked"
            ></ion-checkbox>
            <br />
          </ion-col> -->
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-textarea
              class="floor_sample_item_note"
              placeholder="Write a note for the item"
              v-model="item_notes"
              rows="3"
            ></ion-textarea>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-button v-if="!status_edit_item" @click="add_item">Add</ion-button>
            <ion-button v-if="status_edit_item" @click="edit_item">Save Changes</ion-button>
          </ion-col>
          <ion-col class="ion-text-right">
            <ion-button @click="item_cancel">Cancel</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div class="selected" v-if="status_selected_list">
      <div class="ion-text-center">
        <h3>Selected Products</h3>
      </div>
      <ion-list>
        <ion-item v-for="item in selected_items" :key="item.pitem_id">
<!--           {{item}} -->
          <ion-grid>
            <ion-row >
              <ion-col size="12" size-md="12" style="padding:0px;margin:0px;" class="ion-text-right">
                 <ion-button style="padding:0px;margin:0px;" @click="edit_item_info(item)">Edit</ion-button>
              </ion-col>
              <ion-col size="4" size-md="3">
                <ion-label> SKU: </ion-label> {{ item.pitem_code }}
              </ion-col>
              <ion-col size="8" size-md="5" class="ion-text-left">
                <ion-label> Name: </ion-label> {{ item.prod_name }}
              </ion-col>
              <ion-col size="12" size-md="4">
                <ion-label>by</ion-label>
                {{ item.ent_fullname }}
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12" size-md="8">
                <div v-if="item.pitem_dimension!=''">
                  <ion-label> Dimension: </ion-label>
                  {{ item.pitem_dimension }}
                  <br>
                </div>
                <div v-if="item.prod_descr!='' && item.hasOwnProperty('prod_descr')">
                  <ion-label> Description: </ion-label>
                  {{ item.prod_descr }}
                  <br>
                </div>
                <div v-if="item.item_note!=''">
                  <br>
                  <ion-label> Note: </ion-label>
                  {{ item.item_note }}
                  <br>
                </div>
              </ion-col>
              <ion-col size="12" size-md="4" class="ion-text-right">
                  <ion-button color="warning" v-if="item.choices.includes('[Tearsheet]') && item.tearsheet_checked==true" @click="toggle(item,'T')">Tearsheet</ion-button>
                  <ion-button color="light" v-if="item.choices.includes('[Tearsheet]') && item.tearsheet_checked!=true" @click="toggle(item,'T')">No Tearsheet</ion-button>

                  <ion-button color="primary" v-if="item.choices.includes('[Sample]') && item.memo_checked==true" @click="toggle(item,'M')">Sample</ion-button>
                  <ion-button color="light" v-if="item.choices.includes('[Sample]') && item.memo_checked!=true" @click="toggle(item,'M')">No Sample</ion-button>

                  <ion-button color="success" v-if="item.choices.includes('[Quote]') && item.quote_checked==true" @click="toggle(item,'Q')">Quote</ion-button>
                  <ion-button color="light" v-if="item.choices.includes('[Quote]') && item.quote_checked!=true" @click="toggle(item,'Q')">No Quote</ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ion-list>

<!--       <ion-list class="newVisitItems_ionList">
        <ion-item v-for="item in selected_items" :key="item.pitem_id">
          <ion-label @click="go_to_item_info(item)"
            >{{ item.prod_name }}{{ item.pitem_code }}</ion-label
          >
        </ion-item>
      </ion-list>-->
    </div>
  </div>
</template>

<script>
import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonList,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  //IonCheckbox,
  IonIcon,
  modalController,
  IonSearchbar,
  IonTextarea,
  alertController
} from "@ionic/vue";
import ScanQRcode from "../ScanQRcode.vue";
import ScanQRcodeHTML5 from "../ScanQRcodeHTML5.vue";
import { searchOutline, qrCodeOutline } from "ionicons/icons";

export default {
  components: {
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonItem,
    IonLabel,
    IonList,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
    //IonCheckbox,
    IonIcon,
    IonSearchbar,
    IonTextarea
  },

  data() {
    return {
      show_navigation_buttons:true,
      status_search_text: true,
      status_scan_product: false,
      status_search_results: false,
      status_item_info: false,
      status_selected_list: true,
      status_edit_item:false,
      error: "",

      search_term: "",

      show_scroll: false,
      items_for_display: [],
      downloaded_items: [],
      limit: 20,
      offset: 0,

      selected_item: {},
      tearsheet_enabled: false,
      memo_enabled: false,
      quote_enabled: false,
      tearsheet_checked: false,
      memo_checked: false,
      quote_checked: false,
      item_notes: '',

      searchOutline,
      qrCodeOutline,

      audioOK: new Audio('/app/assets/sounds/beep.mp3'),
    };
  },

  computed: {
    selected_items() {
      return this.$store.getters["visits/getSelectedItems"];
    },
  },

  methods: {
    get_items() {

      this.items_for_display = [];
      this.limit = 20,
      this.offset = 0,
      this.show_scroll = true;
      this.loadData(this.$event, false);
    },

    cancelSearch(){
      // go to the selected items screen
      // screen's components variables
      this.show_navigation_buttons = true;
      this.status_search_text = true;
      this.status_scan_product = false;
      this.status_search_results = false;
      this.status_item_info = false;
      this.status_selected_list = true;
      this.status_edit_item = false,
      this.error = "";
    },

    async toggle(item,subject) {
      if (subject=='T') {
        if (item.tearsheet_checked==undefined) {
          item.tearsheet_checked = false;
        }
        item.tearsheet_checked = !item.tearsheet_checked;
      }
      if (subject=='M') {
        if (item.memo_checked==undefined) {
          item.memo_checked = false;
        }
        item.memo_checked = !item.memo_checked;
      }
      if (subject=='Q') {
        if (item.quote_checked==undefined) {
          item.quote_checked = false;
        }
        item.quote_checked = !item.quote_checked;
      }

      // Inform the server and update the store.
      var selected_options = "";
      if (item.tearsheet_checked) {
        selected_options += "[TEARSHEET]";
      }
      if (item.memo_checked) {
        selected_options += "[SAMPLE]";
      }
      if (item.quote_checked) {
        selected_options += "[QUOTE]";
      }

      await this.$store.dispatch("visits/visit_edit_item", {
        flvisi_id: item.flvisi_id,
        flvis_id: this.$store.getters["visits/getCurrentVisitId"],
        flvisi_type: 0, // product
        pitem_id: item.pitem_id,
        inv_id: 0,
        options: selected_options,
        options_details: "",
        flvisi_notes: item.item_note,
        conn_id: item.master_conn_id
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        this.error = error;
      } else {
        // inform existing selected item
        this.error = '';
        this.$store.commit("visits/informSelectedItem", {flvisi_id:item.flvisi_id,
                                                          tearsheet:item.tearsheet_checked,
                                                          memo:item.memo_checked,
                                                          quote:item.quote_checked,
                                                          note: item.item_note});  // This call might not be required!!! Check it
      }

    },

    async loadData(event, call_event) {

      await this.$store.dispatch("visits/items_search", {
        search_term: this.search_term,
        offset: this.offset,
        limit: this.limit
      });
      var error = this.$store.getters["visits/getRequestError"];
      this.offset += this.limit; // prepare for next search.

      if (error != "") {
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = error;
        this.offset = 0;
      } else {
        this.downloaded_items = this.$store.getters["visits/getItemsFromSearch"];

        for(let i=0; i<this.downloaded_items.length; i++)
          this.items_for_display.push(this.downloaded_items[i]);

        if(this.downloaded_items.length<this.limit)
          this.show_scroll = false;

        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = true;
        this.status_item_info = false;
        this.status_selected_list = false;
        this.status_edit_item = false,
        this.error = "";
      }

      if (call_event) event.target.complete();
    },

    go_to_item_info(item) {
      this.selected_item = item;

      // add item to the list of this visit
      this.add_item_to_list();

      // // enable/disable choices
      // this.tearsheet_enabled = false;
      // if(this.selected_item.choices.includes('[Tearsheet]'))
      //   this.tearsheet_enabled = true;
      // this.memo_enabled = false;
      // if(this.selected_item.choices.includes('[Sample]'))
      //   this.memo_enabled = true;
      // this.quote_enabled = false;
      // if(this.selected_item.choices.includes('[Quote]'))
      //   this.quote_enabled = true;

      // // clear selections
      // this.tearsheet_checked = false;
      // this.memo_checked = false;
      // this.quote_checked = false;
      // this.item_notes = '';
      // // screen's components variables
      // this.show_navigation_buttons = false;
      // this.status_search_text = false;
      // this.status_scan_product = false;
      // this.status_search_results = false;
      // this.status_item_info = true;
      // this.status_selected_list = false;
      // this.status_edit_item = false,
      // this.error = "";
    },

    edit_item_info(item) {
      this.selected_item = item;
      console.log(this.selected_item);
      // enable/disable choices
      this.tearsheet_enabled = false;
      if(this.selected_item.choices.includes('[Tearsheet]'))
        this.tearsheet_enabled = true;
      this.memo_enabled = false;
      if(this.selected_item.choices.includes('[Sample]'))
        this.memo_enabled = true;
      this.quote_enabled = false;
      if(this.selected_item.choices.includes('[Quote]'))
        this.quote_enabled = true;

      // restore selections from the selected item
      this.tearsheet_checked = this.selected_item.tearsheet_checked;
      this.memo_checked = this.selected_item.memo_checked;
      this.quote_checked = this.selected_item.quote_checked;
      this.item_notes = this.selected_item.item_note;
      // screen's components variables
      this.show_navigation_buttons = false;
      this.status_search_text = false;
      this.status_scan_product = false;
      this.status_search_results = false;
      this.status_item_info = true;
      this.status_selected_list = false;
      this.status_edit_item = true,
      this.error = "";
    },

    async add_item() {
      console.log("Add item");

      console.log("tearsheets checked: " + this.tearsheet_checked);
      console.log("memo checked: " + this.memo_checked);
      console.log("quote checked: " + this.quote_checked);

      var selected_options = "";
      if (this.tearsheet_checked) {
        selected_options += "[TEARSHEET]";
      }
      if (this.memo_checked) {
        selected_options += "[SAMPLE]";
      }
      if (this.quote_checked) {
        selected_options += "[QUOTE]";
      }

      await this.$store.dispatch("visits/visit_add_item", {
        flvis_id: this.$store.getters["visits/getCurrentVisitId"],
        flvisi_type: 0, // product
        pitem_id: this.selected_item.pitem_id,
        inv_id: 0,
        options: selected_options,
        options_details: "",
        flvisi_notes: this.item_notes,
        conn_id: this.selected_item.master_conn_id
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        // go to the selected items screen
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = error;

      } else {
        // push to the selected items
        this.selected_item.flvisi_id = this.$store.getters["visits/getInsertedItemId"];
        this.selected_item.tearsheet_checked = this.tearsheet_checked;
        this.selected_item.memo_checked = this.memo_checked;
        this.selected_item.quote_checked = this.quote_checked;
        this.selected_item.item_note = this.item_notes;

        // insert the selected item to the state
        this.$store.commit("visits/insertSelectedItem", this.selected_item);

        // go to the selected items screen
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = "";
      }
    },

    async edit_item() {
      console.log("Add item");

      console.log("tearsheets checked: " + this.tearsheet_checked);
      console.log("memo checked: " + this.memo_checked);
      console.log("quote checked: " + this.quote_checked);

      var selected_options = "";
      if (this.tearsheet_checked) {
        selected_options += "[TEARSHEET]";
      }
      if (this.memo_checked) {
        selected_options += "[SAMPLE]";
      }
      if (this.quote_checked) {
        selected_options += "[QUOTE]";
      }

      await this.$store.dispatch("visits/visit_edit_item", {
        flvisi_id: this.selected_item.flvisi_id,
        flvis_id: this.$store.getters["visits/getCurrentVisitId"],
        flvisi_type: 0, // product
        pitem_id: this.selected_item.pitem_id,
        inv_id: 0,
        options: selected_options,
        options_details: "",
        flvisi_notes: this.item_notes,
        conn_id: this.selected_item.master_conn_id
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        // go to the selected items screen
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = error;
      } else {
        // inform existing selected item
        this.$store.commit("visits/informSelectedItem", {flvisi_id:this.selected_item.flvisi_id,
                                                          tearsheet:this.tearsheet_checked,
                                                          memo:this.memo_checked,
                                                          quote:this.quote_checked,
                                                          note:this.item_notes});

        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = "";
      }
    },

    async remove(){
      console.log('Delete item with id '+this.selected_item.flvisi_id);
      await this.$store.dispatch("visits/visit_delete_item", { flvisi_id: this.selected_item.flvisi_id });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        this.error = error;
      } else {
        // remove selected item from item's list
        this.$store.commit("visits/removeSelectedItem", {flvisi_id:this.selected_item.flvisi_id});
        this.error = "";
      }

      // screen's components variables
      this.show_navigation_buttons = true;
      this.status_search_text = true;
      this.status_scan_product = false;
      this.status_search_results = false;
      this.status_item_info = false;
      this.status_selected_list = true;
      this.status_edit_item = false;
    },

    item_cancel() {
      this.selected_item = {};
      this.tearsheet_checked = false;
      this.memo_checked = false;
      this.quote_checked = false;
      this.item_notes = '';

      // screen's components variables
      this.show_navigation_buttons = true;
      this.status_search_text = true;
      this.status_scan_product = false;
      this.status_search_results = false;
      this.status_item_info = false;
      this.status_selected_list = true;
      this.status_edit_item = false,
      this.error = "";
    },

    async start_scan() {

      this.audioOK.autoplay = true;

      // screen's components variables
      this.show_navigation_buttons = false;
      this.status_search_text = false;
        // this.status_scan_product=true,
      this.status_search_results = false,
      this.status_item_info = false;
      this.status_selected_list = false;
      this.status_edit_item = false,
      this.error = "";

      const modal = await modalController.create({
        component: ScanQRcode,
        cssClass: 'custModal',
        componentProps: {
          title: "New_Visit",
        },
      });

      var currentComponent = this;
      modal.onDidDismiss().then((modelData) => {
        if (modelData !== null) {
          this.modelData = modelData.data;
          if(modelData.data!='cancelled'){
            currentComponent.search_scanned_product(modelData.data);
          } else {
            currentComponent.show_navigation_buttons = true;
            currentComponent.status_search_text = true;
            currentComponent.status_scan_product = false;
            currentComponent.status_search_results = false;
            currentComponent.status_item_info = false;
            currentComponent.status_selected_list = true;
            currentComponent.status_edit_item = false,
            currentComponent.error = '';
          }
        }
      });
      return modal.present();
    },

    async start_scan_with_html5() {
      // screen's components variables
      this.show_navigation_buttons = false;
      this.status_search_text = false;
        // this.status_scan_product=true,
      this.status_search_results = false,
      this.status_item_info = false;
      this.status_selected_list = false;
      this.status_edit_item = false,
      this.error = "";

      const modal = await modalController.create({
        component: ScanQRcodeHTML5,
        cssClass: 'custModal',
        componentProps: {
          title: "Scan Product",
        },
      });

      var currentComponent = this;
      modal.onDidDismiss().then((modelData) => {
        if (modelData !== null) {
          this.modelData = modelData.data;
          if(modelData.data!='cancelled'){
            currentComponent.search_scanned_product(modelData.data);
          } else {
            currentComponent.show_navigation_buttons = true;
            currentComponent.status_search_text = true;
            currentComponent.status_scan_product = false;
            currentComponent.status_search_results = false;
            currentComponent.status_item_info = false;
            currentComponent.status_selected_list = true;
            currentComponent.status_edit_item = false,
            currentComponent.error = '';
          }
        }
      });
      return modal.present();
    },

    async search_scanned_product(scanned_code) {
      console.log("Scanned code is: " + scanned_code);

      await this.$store.dispatch("visits/item_scan", { code: scanned_code });
      var error = this.$store.getters["visits/getRequestError"];
      console.log("Error: " + error);

      if (error != "") {
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = error;
      } else {
        console.log("Scanned complete");

        var scanResult = this.$store.getters["visits/getItemFromScan"];
        if (scanResult.inventory==false) {
            this.selected_item = scanResult.product;
        } else {
            //this.selected_item = scanResult.inventory;
            this.selected_item = scanResult.product; // This should be inventory
        }

        // add item to the list of this visit
        this.add_item_to_list();
      }
    },

    async add_item_to_list(){

      var selected_options = "";
      if (this.selected_item.ptype_id==1 || this.selected_item.ptype_id==2 || this.selected_item.ptype_id==5 || this.selected_item.ptype_id==8) {
        selected_options += "[TEARSHEET]";
        // set selections
        this.tearsheet_checked = true;
        this.memo_checked = false;
        this.quote_checked = false;
        this.item_notes = '';
      }
      if (this.selected_item.ptype_id==3 || this.selected_item.ptype_id==4 || this.selected_item.ptype_id==7 || this.selected_item.ptype_id==6) {
        selected_options += "[TEARSHEET][SAMPLE]";
        // set selections
        this.tearsheet_checked = true;
        this.memo_checked = true;
        this.quote_checked = false;
        this.item_notes = '';
      }

      await this.$store.dispatch("visits/visit_add_item", {
        flvis_id: this.$store.getters["visits/getCurrentVisitId"],
        flvisi_type: 0, // product
        pitem_id: this.selected_item.pitem_id,
        inv_id: 0,
        options: selected_options,
        options_details: "",
        flvisi_notes: "",
        conn_id: this.selected_item.master_conn_id
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        // go to the selected items screen
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = error;
      } else {
        // push to the selected items
        this.selected_item.flvisi_id = this.$store.getters["visits/getInsertedItemId"];
        this.selected_item.tearsheet_checked = this.tearsheet_checked;
        this.selected_item.memo_checked = this.memo_checked;
        this.selected_item.quote_checked = this.quote_checked;
        this.selected_item.item_note = this.item_notes;

        // insert the selected item to the state
        this.$store.commit("visits/insertSelectedItem", this.selected_item);

        // go to the selected items screen
        // screen's components variables
        this.show_navigation_buttons = true;
        this.status_search_text = true;
        this.status_scan_product = false;
        this.status_search_results = false;
        this.status_item_info = false;
        this.status_selected_list = true;
        this.status_edit_item = false,
        this.error = "";
      }

    },

    emptyFields(){
      this.show_navigation_buttons = true;
      this.status_search_text = true;
      this.status_scan_product = false;
      this.status_search_results = false;
      this.status_item_info = false;
      this.status_selected_list = true;
      this.status_edit_item = false;
      this.error = '';
    },

    go_to_first_step() {
      this.$emit("go_to_first", "back_to_first");
    },

    async go_to_third_step() {
      var selected_items = this.$store.getters["visits/getSelectedItems"];
      if(selected_items.length==0){

        const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Empty list',
            message: 'You have not selected any products, are you sure that you want to continue?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'Ok',
                role: 'ok',
                id: 'confirm-button',
                handler: () => {
                  console.log('Confirm Okay')
                },
              },
            ],
          });
        await alert.present();

        const { role } = await alert.onDidDismiss();
        console.log('answer: '+role)
        if(role == 'ok'){
          this.$emit("go_to_third", "items_selected");
        }

      } else {
        this.$emit("go_to_third", "items_selected");
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.results {

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
/*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #226391;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }

}

.selected {

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
/*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid red;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }

}

.information {

  font-size:0.95em;

  .conf-name {
    color: #000;
  }

  ion-row {
    background: #ffffff;
/*     margin-bottom: 10px; */
    padding: 10px;
    border-left: 10px solid #079602;
    height: auto;
  }

  .no-date {
    font-style: italic;
  }

  a {
    text-decoration: none;
  }

  ion-grid {
    height: auto;
  }

  ion-item {
    border: none;
  }

  ion-label {
    font-size: 0.8em;
    font-weight: bold;
    color: #444;
  }

}
.error {
  color: red;
  font-size: 15px;
}

/*     ion-input {
        border: 1px solid #cbcbcb;
        border-radius: 3px;
        font-size: 14px;
        --padding-start: 10px !important;
        --padding-top: 10px !important;
        --padding-bottom: 10px !important;
    }

    ion-button {
        color: #404040;
        --background: #ffffff;
    } */

ion-input {
  background: #fff;
  border-radius: 8px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

.button_nav {
  border-radius: 0;
  height: 40px;
  width: 100px;
  color: #fff;
  --background: #E87E04;
}

.text {
  padding: 5px 10px;
}

.floor_sample_item_note {
  width: 100%;
  height: 80px;
  background: #efefef;
  margin-top: 0px;
  border-radius: 8px;
  border: 1px solide #333;
  padding: 3px 8px !important;
}


</style>
